import * as React from 'react';
import './ParentDesign.scss';

export interface ParentHeaderChip {
  label: string;
  value?: React.ReactNode;
  tone?: 'blue' | 'green' | 'amber' | 'slate' | 'red';
}

interface Props {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  chips?: ParentHeaderChip[];
  actions?: React.ReactNode;
  tabs?: Array<{ label: string; active?: boolean; count?: number; onClick: () => void }>;
}

export const ParentPageHeader = ({ title, subtitle, chips = [], actions, tabs = [] }: Props) => (
  <header className={tabs.length ? 'parentPageHeader parentPageHeader--withTabs' : 'parentPageHeader'}>
    <div className="parentPageHeader__main">
      <div className="parentPageHeader__copy">
        <h1>{title}</h1>
        {subtitle ? <p>{subtitle}</p> : null}
      </div>
      {tabs.length > 0 ? (
        <nav className="parentPageHeader__tabs" aria-label="Page sections">
          {tabs.map(tab => (
            <button type="button" className={tab.active ? 'is-active' : ''} onClick={tab.onClick} key={tab.label}>
              {tab.label}
              {typeof tab.count === 'number' ? <span>{tab.count}</span> : null}
            </button>
          ))}
        </nav>
      ) : null}
      {chips.length > 0 ? (
        <div className="parentPageHeader__chips" aria-label="Page summary">
          {chips.map((chip, index) => (
            <span className={`parentSummaryChip parentSummaryChip--${chip.tone || 'slate'}`} key={`${chip.label}_${index}`}>
              {typeof chip.value !== 'undefined' ? <strong>{chip.value}</strong> : null}
              <span>{chip.label}</span>
            </span>
          ))}
        </div>
      ) : null}
    </div>
    {actions ? <div className="parentPageHeader__actions">{actions}</div> : null}
  </header>
);

ParentPageHeader.displayName = 'ParentPageHeader';
